<div class="dashboard-page">
  @if(movementsBlocked) {
  <div class="dashboard-alert dashboard-alert--error">
    <p-message severity="error" icon="pi pi-ban"
      [text]="'DASHBOARD.BANNER_MOVEMENTS_BLOCKED' | translate: { periods: openPeriodsDisplay }" />
  </div>
  }

  <header class="dashboard-hero">
    <div class="dashboard-hero__inner">
      <div class="dashboard-hero__brand">
        <div class="dashboard-hero__icon" aria-hidden="true">
          <i class="pi pi-chart-bar"></i>
        </div>
        <div class="dashboard-hero__text">
          <span class="dashboard-hero__eyebrow">{{ 'DASHBOARD.HERO_EYEBROW' | translate }}</span>
          <h1 class="dashboard-hero__title">{{ 'DASHBOARD.TITLE' | translate }}</h1>
        </div>
      </div>
      <div class="dashboard-hero__meta">
        @if (showBanner) {
        <span class="dashboard-hero__chip dashboard-hero__chip--warn">
          <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
          {{ 'DASHBOARD.BANNER_PENDING' | translate: { month: previousMonthName } }}
        </span>
        }
        <span class="dashboard-hero__chip">
          <i class="pi pi-calendar" aria-hidden="true"></i>
          <span class="notranslate">{{ currentDate | uppercase }}</span>
        </span>
      </div>
    </div>
  </header>

  <div class="dashboard-kpi-grid">
    @if (hasAccess(['Admin', 'Pastor', 'Tesorería', 'access_finanzas'])) {
    <article class="dashboard-kpi dashboard-kpi--success">
      <div class="dashboard-kpi__icon">
        <fa-icon [icon]="['fas', 'wallet']"></fa-icon>
      </div>
      <div class="dashboard-kpi__body">
        <span class="dashboard-kpi__label">{{ 'DASHBOARD.BALANCE_CAJA' | translate }}</span>
        <p class="dashboard-kpi__value">{{ totalSaldoEnCaja | missionMoney }}</p>
      </div>
    </article>
    } @else {
    <article class="dashboard-kpi dashboard-kpi--locked">
      <div class="dashboard-kpi__locked">
        <i class="pi pi-lock" aria-hidden="true"></i>
        <span>{{ 'DASHBOARD.ACCESS_DENIED_FINANCE' | translate }}</span>
      </div>
    </article>
    }

    <article class="dashboard-kpi dashboard-kpi--brand">
      <div class="dashboard-kpi__icon">
        <fa-icon [icon]="['fas', 'users']"></fa-icon>
      </div>
      <div class="dashboard-kpi__body">
        <span class="dashboard-kpi__label">{{ 'DASHBOARD.STAT_MEMBERS' | translate }}</span>
        <p class="dashboard-kpi__value">{{ members.length }}</p>
      </div>
    </article>

    <article class="dashboard-kpi dashboard-kpi--warning">
      <div class="dashboard-kpi__icon">
        <fa-icon [icon]="['fas', 'tasks']"></fa-icon>
      </div>
      <div class="dashboard-kpi__body">
        <span class="dashboard-kpi__label">{{ 'DASHBOARD.STAT_TASKS' | translate }}</span>
        <p class="dashboard-kpi__value">{{ pendingTasksCount }}</p>
      </div>
    </article>

    <article class="dashboard-kpi dashboard-kpi--info">
      <div class="dashboard-kpi__icon">
        <fa-icon [icon]="['fas', 'calendar-check']"></fa-icon>
      </div>
      <div class="dashboard-kpi__body">
        <span class="dashboard-kpi__label">{{ 'DASHBOARD.STAT_EVENTS' | translate }}</span>
        <p class="dashboard-kpi__value">{{ upcomingEvents.length }}</p>
      </div>
    </article>
  </div>

  <div class="dashboard-layout">
    <div class="dashboard-layout__main">
      @if (hasAccess(['Admin', 'Pastor', 'Tesorería', 'access_finanzas'])) {
      <article class="dashboard-panel">
        <header class="dashboard-panel__head">
          <div class="dashboard-panel__icon dashboard-panel__icon--finance">
            <i class="pi pi-chart-pie"></i>
          </div>
          <div class="dashboard-panel__titles">
            <h2 class="dashboard-panel__title">{{ 'DASHBOARD.FINANCE_SUMMARY' | translate }}</h2>
            <p class="dashboard-panel__desc">{{ 'DASHBOARD.SUBTITLE' | translate }}</p>
          </div>
        </header>
        <div class="dashboard-panel__body">
          <div class="dashboard-mini-stats">
            <div class="dashboard-mini-stat dashboard-mini-stat--success">
              <span class="dashboard-mini-stat__label">{{ 'DASHBOARD.INCOME' | translate }}</span>
              <span class="dashboard-mini-stat__value">{{ totalEntradasMesActual | missionMoney }}</span>
            </div>
            <div class="dashboard-mini-stat dashboard-mini-stat--danger">
              <span class="dashboard-mini-stat__label">{{ 'DASHBOARD.EXPENSES' | translate }}</span>
              <span class="dashboard-mini-stat__value">{{ totalSalidasMesActual | missionMoney }}</span>
            </div>
            <div class="dashboard-mini-stat dashboard-mini-stat--brand">
              <span class="dashboard-mini-stat__label">{{ 'DASHBOARD.BALANCE_CAJA' | translate }}</span>
              <span class="dashboard-mini-stat__value">{{ totalSaldoEnCaja | missionMoney }}</span>
            </div>
          </div>
          <div class="dashboard-chart">
            @if(options) {
            <div echarts [options]="options" [theme]="theme" class="dashboard-chart__canvas"></div>
            } @else {
            <div class="dashboard-chart__loading">
              <i class="pi pi-spin pi-spinner"></i>
            </div>
            }
          </div>
        </div>
      </article>
      } @else {
      <article class="dashboard-panel">
        <div class="dashboard-panel__body">
          <div class="dashboard-no-access">
            <i class="pi pi-lock" aria-hidden="true"></i>
            <h3>{{ 'DASHBOARD.ACCESS_DENIED_TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.ACCESS_DENIED_FINANCE' | translate }}</p>
          </div>
        </div>
      </article>
      }

      <article class="dashboard-panel">
        <header class="dashboard-panel__head dashboard-panel__head--toolbar">
          <div class="dashboard-panel__icon dashboard-panel__icon--accent">
            <i class="pi pi-check-square"></i>
          </div>
          <div class="dashboard-panel__titles">
            <h2 class="dashboard-panel__title">{{ 'DASHBOARD.TASKS_WIDGET' | translate }}</h2>
          </div>
          @if(pendingTasksCount > 0) {
          <p-badge [value]="pendingTasksCount.toString()" severity="warn" />
          }
        </header>
        <div class="dashboard-panel__body">
          @if(upcomingTasks.length > 0) {
          <ul class="dashboard-task-list">
            @for(task of upcomingTasks; track task.id) {
            <li class="dashboard-task">
              <span class="dashboard-task__priority" [ngClass]="{
                'dashboard-task__priority--high': task.priority === 'Alta',
                'dashboard-task__priority--medium': task.priority === 'Media',
                'dashboard-task__priority--low': task.priority === 'Baja'
              }"></span>
              <div class="dashboard-task__content">
                <h3 class="dashboard-task__title">{{ task.title }}</h3>
                @if (task.description) {
                <p class="dashboard-task__desc">{{ task.description }}</p>
                }
                <div class="dashboard-task__meta">
                  <p-tag [value]="task.category" severity="info" />
                  <p-tag [value]="task.priority" [severity]="getPriority(task.priority)" />
                  <span class="dashboard-task__date">
                    <i class="pi pi-calendar" aria-hidden="true"></i>
                    {{ convertDate(task.dueDateTime) }}
                  </span>
                </div>
              </div>
            </li>
            }
          </ul>
          } @else {
          <div class="dashboard-empty">
            <i class="pi pi-check-circle" aria-hidden="true"></i>
            <p>{{ 'DASHBOARD.NO_TASKS' | translate }}</p>
          </div>
          }
        </div>
      </article>
    </div>

    <aside class="dashboard-layout__aside">
      @if (hasAccess(['Admin', 'Pastor', 'Secretaría', 'access_membresia'])) {
      <article class="dashboard-panel">
        <header class="dashboard-panel__head">
          <div class="dashboard-panel__icon dashboard-panel__icon--brand">
            <i class="pi pi-users"></i>
          </div>
          <div class="dashboard-panel__titles">
            <h2 class="dashboard-panel__title">{{ 'DASHBOARD.MEMBERSHIP_SUMMARY' | translate }}</h2>
          </div>
        </header>
        <div class="dashboard-panel__body">
          <div class="dashboard-member-stats">
            <div class="dashboard-member-stat">
              <span class="dashboard-member-stat__label">{{ 'DASHBOARD.MEMBERS_ACTIVE' | translate }}</span>
              <span class="dashboard-member-stat__value">{{ miembrosActivos }}</span>
            </div>
            <div class="dashboard-member-stat">
              <span class="dashboard-member-stat__label">{{ 'DASHBOARD.MEMBERS_BAPTIZED' | translate }}</span>
              <span class="dashboard-member-stat__value">{{ bautizadosCount }}</span>
            </div>
            <div class="dashboard-member-stat">
              <span class="dashboard-member-stat__label">{{ 'DASHBOARD.MEMBERS_MEN' | translate }}</span>
              <span class="dashboard-member-stat__value">{{ hombresCount }}</span>
            </div>
            <div class="dashboard-member-stat">
              <span class="dashboard-member-stat__label">{{ 'DASHBOARD.MEMBERS_WOMEN' | translate }}</span>
              <span class="dashboard-member-stat__value">{{ mujeresCount }}</span>
            </div>
          </div>
          <div class="dashboard-chart dashboard-chart--sm">
            @if(memberOptions) {
            <div echarts [options]="memberOptions" [merge]="memberMerge" [theme]="macaronsTheme"
              class="dashboard-chart__canvas"></div>
            } @else {
            <div class="dashboard-chart__loading">
              <i class="pi pi-spin pi-spinner"></i>
            </div>
            }
          </div>
        </div>
      </article>
      } @else {
      <article class="dashboard-panel">
        <div class="dashboard-panel__body">
          <div class="dashboard-no-access dashboard-no-access--tall">
            <i class="pi pi-lock" aria-hidden="true"></i>
            <h3>{{ 'DASHBOARD.ACCESS_DENIED_TITLE' | translate }}</h3>
            <p>{{ 'DASHBOARD.ACCESS_DENIED_MEMBERSHIP' | translate }}</p>
          </div>
        </div>
      </article>
      }

      <article class="dashboard-panel">
        <header class="dashboard-panel__head">
          <div class="dashboard-panel__icon dashboard-panel__icon--warning">
            <i class="pi pi-bell"></i>
          </div>
          <div class="dashboard-panel__titles">
            <h2 class="dashboard-panel__title">{{ 'DASHBOARD.NOTIFICATIONS' | translate }}</h2>
          </div>
        </header>
        <div class="dashboard-panel__body">
          <ul class="dashboard-notifications">
            @if(supportUnreadCount > 0) {
            <li class="dashboard-notification dashboard-notification--warn dashboard-notification--action">
              <span class="dashboard-notification__icon"><i class="pi pi-headphones"></i></span>
              <div class="dashboard-notification__content">
                <h3 class="dashboard-notification__title">{{ 'DASHBOARD.NOTIF_SUPPORT_TITLE' | translate }}</h3>
                <p class="dashboard-notification__text">
                  {{
                    (supportUnreadCount === 1
                      ? 'DASHBOARD.NOTIF_SUPPORT_TEXT_ONE'
                      : 'DASHBOARD.NOTIF_SUPPORT_TEXT_MANY'
                    ) | translate: { count: supportUnreadCount }
                  }}
                </p>
                <button type="button" class="dashboard-notification__cta" (click)="openSupportUnread()">
                  {{ 'DASHBOARD.NOTIF_SUPPORT_CTA' | translate }}
                  <i class="pi pi-arrow-right" aria-hidden="true"></i>
                </button>
              </div>
            </li>
            }

            @if(upcomingEvents.length > 0) {
            <li class="dashboard-notification dashboard-notification--info">
              <span class="dashboard-notification__icon"><i class="pi pi-calendar"></i></span>
              <div class="dashboard-notification__content">
                <h3 class="dashboard-notification__title">{{ 'DASHBOARD.NOTIF_NEXT_EVENT' | translate }}</h3>
                <p class="dashboard-notification__text">{{ upcomingEvents[0].title }}</p>
                @if(nextEventDate) {
                <small class="dashboard-notification__date">{{ nextEventDate }}</small>
                }
              </div>
            </li>
            }

            @if(pendingTasksCount > 5) {
            <li class="dashboard-notification dashboard-notification--warn">
              <span class="dashboard-notification__icon"><i class="pi pi-exclamation-triangle"></i></span>
              <div class="dashboard-notification__content">
                <h3 class="dashboard-notification__title">{{ 'DASHBOARD.NOTIF_TASKS_TITLE' | translate }}</h3>
                <p class="dashboard-notification__text">{{ 'DASHBOARD.NOTIF_TASKS_TEXT' | translate: { count: pendingTasksCount } }}</p>
              </div>
            </li>
            }

            @if(saldoDisponible < 0) {
            <li class="dashboard-notification dashboard-notification--danger">
              <span class="dashboard-notification__icon"><i class="pi pi-exclamation-circle"></i></span>
              <div class="dashboard-notification__content">
                <h3 class="dashboard-notification__title">{{ 'DASHBOARD.NOTIF_NEG_BALANCE_TITLE' | translate }}</h3>
                <p class="dashboard-notification__text">{{ 'DASHBOARD.NOTIF_NEG_BALANCE_TEXT' | translate }}</p>
              </div>
            </li>
            }

            @if(supportUnreadCount === 0 && upcomingEvents.length === 0 && pendingTasksCount <= 5 && saldoDisponible >= 0) {
            <li class="dashboard-empty dashboard-empty--inline">
              <i class="pi pi-check-circle" aria-hidden="true"></i>
              <p>{{ 'DASHBOARD.NO_NOTIFICATIONS' | translate }}</p>
            </li>
            }
          </ul>
        </div>
      </article>
    </aside>
  </div>
</div>
